const translator = {
  en: {
    translator: {
      head: {
        dragToReorder: 'Drag to reorder',
        translateTo: 'Translate to',
        style: 'Style',
        generalObjective: 'General',
        deleteCardTitle: 'Delete Translation Card',
        deleteCardMessage: 'Are you sure you want to remove the translation card for {lang}?',
      },
      objective: {
        general: 'General',
        learning: 'Learning',
        business: 'Business',
        social: 'Social',
        travel: 'Travel',
      },
      footer: {
        tone: 'Tone',
        casual: 'Casual',
        standard: 'Standard',
        formal: 'Formal',
        listen: 'Listen',
      },
      languageModal: {
        title: 'Select Language',
        searchPlaceholder: 'Search languages...',
        noResults: 'No languages found',
      },
      source: {
        detectLanguage: 'Detect Language',
        translateFrom: 'Translate from {lang}',
        translate: 'Translate',
        translating: 'Translating',
        placeholder: "Type what you'd like to translate...",
      },
      content: {
        translating: 'Translating...',
        placeholder: 'Translation...',
      },
      workspace: {
        noTranslation: '⚠️ No translation returned for this card.',
        quotaExceeded: '⚠️ Quota Exceeded (Check Profile)',
        translationFailed: '❌ Translation failed. Please try again.',
        modelBusy: '⏳ The translation model is busy right now. Please try again in a moment — your quota was not used.',
        addAnother: 'Add Another Translation',
        addAnotherHint: 'Compare different languages, tones, or contexts side-by-side in one click.',
        cardsUsed: '{count} / {max} Cards Used',
      },
      detail: {
        historyRecord: 'History Record',
        savedWord: 'Saved Word',
        translatedResult: 'Translated Result',
        originalText: 'Original Text',
        copy: 'Copy',
        copied: 'Copied',
        tone: 'Tone:',
        formality: 'Formality:',
        listen: 'Listen',
        auto: 'Auto',
      },
      quotaModal: {
        title: 'Quota Limit Reached',
        bodyBefore: "You've hit your daily limit of",
        tokens: '10,000 tokens',
        bodyAfter: 'Unlock unlimited translations and premium AI models today.',
        feature1: '1,000,000+ Monthly Tokens',
        feature2: 'Custom Translation Objectives',
        feature3: 'Priority API Access',
        notNow: 'Not Now',
        upgrade: 'Upgrade Plan',
      },
      quotaMini: {
        dailyQuota: 'Daily Quota',
        runningLow: 'Running low on tokens',
        limitReached: 'Limit reached. Please upgrade.',
      },
      quotaBar: {
        title: 'Daily Token Quota',
        limitReached: 'Limit Reached',
        tokensUsed: '{used} / {limit} tokens used',
        consumed: '{percent}% Consumed',
        resetsDaily: 'Resets Daily',
      },
      home: {
        addToNotebook: 'Add to Notebook',
        original: 'Original:',
      },
    },
  },
  th: {
    translator: {
      head: {
        dragToReorder: 'ลากเพื่อจัดเรียง',
        translateTo: 'แปลเป็น',
        style: 'สไตล์',
        generalObjective: 'ทั่วไป',
        deleteCardTitle: 'ลบการ์ดการแปล',
        deleteCardMessage: 'คุณแน่ใจหรือไม่ว่าต้องการลบการ์ดการแปลสำหรับ {lang}?',
      },
      objective: {
        general: 'ทั่วไป',
        learning: 'เรียนรู้',
        business: 'ธุรกิจ',
        social: 'โซเชียล',
        travel: 'ท่องเที่ยว',
      },
      footer: {
        tone: 'โทน',
        casual: 'กันเอง',
        standard: 'มาตรฐาน',
        formal: 'ทางการ',
        listen: 'ฟังเสียง',
      },
      languageModal: {
        title: 'เลือกภาษา',
        searchPlaceholder: 'ค้นหาภาษา...',
        noResults: 'ไม่พบภาษา',
      },
      source: {
        detectLanguage: 'ตรวจจับภาษา',
        translateFrom: 'แปลจาก {lang}',
        translate: 'แปล',
        translating: 'กำลังแปล',
        placeholder: 'พิมพ์ข้อความที่คุณต้องการแปล...',
      },
      content: {
        translating: 'กำลังแปล...',
        placeholder: 'คำแปล...',
      },
      workspace: {
        noTranslation: '⚠️ ไม่มีคำแปลสำหรับการ์ดนี้',
        quotaExceeded: '⚠️ ใช้โควตาเกินกำหนด (ตรวจสอบโปรไฟล์)',
        translationFailed: '❌ การแปลล้มเหลว กรุณาลองอีกครั้ง',
        modelBusy: '⏳ ตอนนี้โมเดลแปลภาษามีผู้ใช้งานหนาแน่น กรุณาลองใหม่อีกครั้งในอีกสักครู่ — ระบบยังไม่ได้หักโควตาของคุณ',
        addAnother: 'เพิ่มการแปลอีก',
        addAnotherHint: 'เปรียบเทียบภาษา โทน หรือบริบทต่าง ๆ แบบเคียงข้างกันได้ในคลิกเดียว',
        cardsUsed: 'ใช้ไปแล้ว {count} / {max} การ์ด',
      },
      detail: {
        historyRecord: 'บันทึกประวัติ',
        savedWord: 'คำที่บันทึก',
        translatedResult: 'ผลการแปล',
        originalText: 'ข้อความต้นฉบับ',
        copy: 'คัดลอก',
        copied: 'คัดลอกแล้ว',
        tone: 'โทน:',
        formality: 'ความเป็นทางการ:',
        listen: 'ฟังเสียง',
        auto: 'อัตโนมัติ',
      },
      quotaModal: {
        title: 'ใช้โควตาครบแล้ว',
        bodyBefore: 'คุณใช้โควตารายวันครบแล้วที่',
        tokens: '10,000 โทเคน',
        bodyAfter: 'ปลดล็อกการแปลแบบไม่จำกัดและโมเดล AI ระดับพรีเมียมวันนี้',
        feature1: 'โทเคนมากกว่า 1,000,000 ต่อเดือน',
        feature2: 'กำหนดวัตถุประสงค์การแปลได้เอง',
        feature3: 'สิทธิ์เข้าถึง API แบบให้ความสำคัญก่อน',
        notNow: 'ไว้ก่อน',
        upgrade: 'อัปเกรดแพ็กเกจ',
      },
      quotaMini: {
        dailyQuota: 'โควตารายวัน',
        runningLow: 'โทเคนใกล้หมดแล้ว',
        limitReached: 'ใช้ครบแล้ว กรุณาอัปเกรด',
      },
      quotaBar: {
        title: 'โควตาโทเคนรายวัน',
        limitReached: 'ใช้ครบแล้ว',
        tokensUsed: 'ใช้ไปแล้ว {used} / {limit} โทเคน',
        consumed: 'ใช้ไป {percent}%',
        resetsDaily: 'รีเซ็ตทุกวัน',
      },
      home: {
        addToNotebook: 'เพิ่มลงในสมุดโน้ต',
        original: 'ต้นฉบับ:',
      },
    },
  },
};

export default translator;
